import { render, staticRenderFns } from "./MyPostulations.vue?vue&type=template&id=6ab6f1d0&scoped=true"
import script from "./MyPostulations.vue?vue&type=script&lang=ts"
export * from "./MyPostulations.vue?vue&type=script&lang=ts"
import style0 from "./MyPostulations.vue?vue&type=style&index=0&id=6ab6f1d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab6f1d0",
  null
  
)

export default component.exports